import { render } from "./proxyLogin.vue?vue&type=template&id=5314d850"
import script from "./proxyLogin.vue?vue&type=script&lang=js"
export * from "./proxyLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__